<div
  [ngClass]="{
    'w-4 h-4': size === '2xs',
    'w-5 h-5': size === 'xs',
    'w-6 h-6': size === 'sm',
    'w-8 h-8': size === 'md',
    'w-10 h-10': size === 'lg',
    'w-11 h-11': size === '2lg',
    'w-12 h-12': size === 'xl',
    'w-24 h-24': size === '2xl',
    'w-32 h-32': size === '3xl',
    'w-full h-full rounded-sm': size === 'customSize'
  }"
  [ngStyle]="customStyles"
  class="overflow-hidden"
  [class.rounded-full]="size !== 'customSize'"
  [class]="styleClass">
  @if (!isImageError && (imgId || src)) {
    @if (preview) {
      <p-image
        styleClass="w-full h-full"
        imageClass="w-full h-full object-cover"
        [src]="getSrcImg()"
        [preview]="true"
        (error)="onImageError()"></p-image>
    } @else {
      <app-custom-image
        styleClass="w-full h-full"
        alt="Avatar"
        [src]="getSrcImg()"
        (error)="onImageError()"></app-custom-image>
    }
  } @else {
    <div
      [ngStyle]="{ 'background-color': backgroundColor, color: textColor }"
      class="w-full h-full flex items-center justify-center text-4"
      [ngClass]="{ 'text-7': size === '2xl' }">
      {{ initials }}
    </div>
  }
</div>
